import fs from 'node:fs';
import type { WirePreviewEnvironmentChildDeps } from './deps.js';

export function startMergedLogPoll(d: WirePreviewEnvironmentChildDeps): void {
  if (!d.mergedLogPath || !d.mergedCleanupDir) return;

  const { environmentId } = d;
  const pollIv = setInterval(() => {
    if ((d.getSpawnGeneration() ?? 0) !== d.scheduledGen) {
      clearInterval(pollIv);
      d.setPollInterval(undefined);
      return;
    }
    fs.readFile(d.mergedLogPath!, (err, buf) => {
      if (err || (d.getSpawnGeneration() ?? 0) !== d.scheduledGen) return;
      if (buf.length <= d.mergedReadPos.value) return;
      const chunk = Buffer.from(buf.subarray(d.mergedReadPos.value));
      d.mergedReadPos.value = buf.length;
      if (chunk.length === 0) return;
      d.stdoutTail.push(chunk);
      d.pushRemoteLogChunk(environmentId, 'stdout', chunk);
    });
  }, 100);
  d.setPollInterval(pollIv);
}
